export interface MemberDrawerRowProps {
  children?: React.ReactNode;
  dataTestId: string;
  label: string;
  value?: string;
}

export const MemberDrawerRow = ({
  children = undefined,
  dataTestId,
  label,
  value = undefined
}: MemberDrawerRowProps) => {
  return (
    <div
      className="flex w-full items-center justify-between text-sm"
      data-testid={`member-drawer-${dataTestId}`}
    >
      <p className="text-soClean-180">{label}</p>
      {value ? (
        <p className="text-soClean-100 max-w-[80%] text-right">{value}</p>
      ) : (
        children
      )}
    </div>
  );
};
